module.exports = __webpack_public_path__ + "static/media/SteelUnicorn_logo.0b94110e.png";